import {
  body,
  icon,
} from './style'
import { CallButtonTypes } from 'types'
import { Icon } from 'icons/Icon'

export const CallButton = ({onClick}:CallButtonTypes) => {
  return (
    <div className={body} onClick={(e) => onClick(e)}>
      <Icon name="CallOn" size={22} className={icon}/>
    </div>
  );
}

